// Stub: resolución de caja activa por establecimiento
import type { Caja, TipoMargenDescuadre } from '@/modelos/Caja';

export class NoActiveCajaError extends Error {
  constructor(message = 'No hay caja activa para el establecimiento') {
    super(message);
    this.name = 'NoActiveCajaError';
  }
}

interface ResolveParams {
  empresaId: string;
  establecimientoId: string;
  cajas: Caja[];
}

export function resolveActiveCajaForEstablecimiento({ establecimientoId, cajas }: ResolveParams): Omit<Caja, 'mediosPagoPermitidos'> & {
  mediosPagoPermitidos: { code: string; label: string }[];
  margenDescuadreCaja: number;
  tipoMargenCaja: TipoMargenDescuadre;
  limiteMaximoCaja: number;
} {
  const caja = cajas.find(
    (c) => c.establecimientoId === establecimientoId && c.esHabilitada && c.esDefecto
  ) ?? cajas.find(
    (c) => c.establecimientoId === establecimientoId && c.esHabilitada
  );

  if (!caja) {
    throw new NoActiveCajaError(`Sin caja activa para establecimiento ${establecimientoId}`);
  }

  return {
    ...caja,
    mediosPagoPermitidos: (caja.medioPagos ?? []).map((mp) => ({ code: mp.codigo, label: mp.nombre })),
    margenDescuadreCaja: caja.margenDescuadre ?? 1,
    tipoMargenCaja: ((caja.tipoMargenDescuadre ?? (caja as unknown as { tipoMargen?: string }).tipoMargen) ?? 'porcentaje') as TipoMargenDescuadre,
    limiteMaximoCaja: caja.limiteMaximo ?? 0,
  };
}
